import { Injectable, signal } from '@angular/core';
import { Observable, of } from 'rxjs';

import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class ThemeConfigService {
  private readonly THEME_CONFIG = 'theme_config';

  isDarkMode = signal(false);

  constructor(private storageService: StorageService) {}

  getTheme(): Observable<{ [key: string]: string }> {
    const theme = this.storageService.getItem(this.THEME_CONFIG);
    if (!theme) return of({});

    return of(JSON.parse(theme));
  }

  setTheme(theme: { [key: string]: string }): void {
    this.storageService.setItem(this.THEME_CONFIG, JSON.stringify(theme));
  }

  loadTheme() {
    const savedTheme = this.storageService.getItem('isDarkMode');
    if (savedTheme !== null) {
      this.isDarkMode.set(savedTheme === 'true');
      this.addStyleDarkMode();
    }
  }

  toggleDarkMode() {
    const isDarkMode = !this.isDarkMode();
    this.storageService.setItem('isDarkMode', String(isDarkMode));
    this.isDarkMode.set(isDarkMode);

    this.addStyleDarkMode();
  }

  private addStyleDarkMode() {
    document.documentElement.classList.toggle('darkMode', this.isDarkMode());
  }
}
